// import Vendors

export const IMPORT_VENDOR_REQUEST = 'IMPORT_VENDOR_REQUEST';
export const IMPORT_VENDOR_SUCCESS = 'IMPORT_VENDOR_SUCCESS';
export const IMPORT_VENDOR_FAIL = 'IMPORT_VENDOR_FAIL';
// clear states
export const CLEAR_IMPORT_VENDOR_STATE = 'CLEAR_IMPORT_VENDOR_STATE';
